import React from 'react'
import Table, { ColumnsType } from 'antd/lib/table'
import { ISupplier } from '@/model/types/supllier'
import { Row } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'
import { AutoResizer, WithScrollLoad } from '@/utils/utils-widget'
import $msg from '@/utils/message'
import { IPagination } from '@/model/types/common'
import { useRequest } from 'ahooks'
import { $post } from '@/api'
import { showLayer } from '@/utils/layer'
import PurchaseSupplierDetail from '../purchase-supplier-detail/purchase-supplier'
import PurchaseSupplierForm from '../purchase-supplier-form/purchase-supplier-form'
import { supplierModel } from '../../model'
import { observer } from 'mobx-react'

interface PurchaseSupplierTableProps {
    refreshStatus: boolean
}

const PurchaseSupplierTable: React.FC<PurchaseSupplierTableProps> = observer(props => {
    const cls = (e?: string, m?: string) => getBEMCls('purchase-supplier', e, m)

    const columns: ColumnsType<ISupplier> = [
        {
            title: '#',
            key: 'index',
            width: 50,
            render: (value, record, index) => index + 1,
        },
        {
            title: '供货商',
            key: 'name',
            dataIndex: 'name',
            render: val => (
                <Row data-align-items-center>
                    <div className={cls('avatar')}>{val[0]}</div>
                    {val}
                </Row>
            ),
        },
        {
            title: '联系电话',
            key: 'phone',
            dataIndex: 'phone',
            render: val => val || <div className="danger-color">无联系电话</div>,
        },
        {
            title: '采购次数',
            key: 'purchase_times',
            dataIndex: 'purchase_times',
            render: val => val,
        },
        {
            title: '操作',
            key: 'action',
            width: 114,
            render: (val, record) => (
                <>
                    <div
                        className={cls('action')}
                        onClick={() => {
                            showLayer(<PurchaseSupplierDetail refresh={requestHandle.refresh} supplierId={record.id} />)
                        }}
                    >
                        详情
                    </div>
                    <div
                        className={cls('action')}
                        style={{
                            marginLeft: '18px',
                        }}
                        onClick={() => {
                            showLayer(<PurchaseSupplierForm refresh={requestHandle.refresh} supplierId={record.id} />)
                        }}
                    >
                        编辑
                    </div>
                </>
            ),
        },
    ]

    const requestHandle = useRequest<
        {
            list: ISupplier[]
            pagination: IPagination
        },
        {
            suppliers: ISupplier[]
            pagination: IPagination
        }
    >(
        val => {
            return $post({
                url: '/warehouse/getshopsuppliers',
                params: {
                    limit: 20,
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    search_keyword: supplierModel.keyWord || void 0,
                },
            })
        },
        {
            isNoMore: data => {
                if (data?.pagination) {
                    return data?.pagination.page === data?.pagination.page_count
                } else {
                    return false
                }
            },
            loadMore: true,
            formatResult: data => {
                return {
                    list: data.suppliers,
                    pagination: data.pagination,
                }
            },
            onError: e => {
                $msg('error', e.message)
            },
            refreshDeps: [props.refreshStatus, supplierModel.keyWord],
        },
    )

    return (
        <div className="table-container">
            <AutoResizer>
                {({ height }) => {
                    return (
                        <WithScrollLoad data-expaned data-overflow-hidden scrollloadhandle={requestHandle}>
                            <Table
                                rowKey={record => record.id}
                                loading={requestHandle.loading || void 0}
                                bordered
                                pagination={false}
                                columns={columns}
                                dataSource={requestHandle.data?.list}
                                scroll={{ x: 'max-content', y: height - 50 }}
                            />
                        </WithScrollLoad>
                    )
                }}
            </AutoResizer>
        </div>
    )
})

export default PurchaseSupplierTable
